import Vue from 'vue'

export default Vue.extend({
  data() {
    return {}
  },
  beforeMount() { },
  mounted() { },
  methods: {
    Clickhandler() {
      let returnID = ''
      if (this.params.data.esId) returnID = this.params.data.esId

      this.params.context.componentParent.Open(returnID)
    },
  },
  template: `
        <span>
            <b-button
            v-b-tooltip.hover="'View'"
            size="sm" 
            @click="Clickhandler()" 
            variant="primary" 
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="btn-icon"
            >
            <font-awesome-icon
              :icon="['fas', 'eye']"
              size="lg"
            />
            </b-button>
        </span>
    `,
})
